angular.module('jv.common.switch.directive', [])
.directive('jvSwitch', [
    function() {

        var bellOff = '<i class="icon icon-alert-off dark-sec"></i>';
        var bellOn = '<i class="icon icon-alert orange"></i>';

        return {
            scope: {
                toggled: '=jvSwitch',
                iconOn: '@',
                iconOff: '@',
                textOn: '@',
                textOff: '@',
                doNotShowBell: '@',
                onToggle: '&',
                powerOnOnly: '@',
                toggleColorBlue: '@'
            },
            link: function(scope) {
                scope.toggle = function() {
                    if (!scope.toggled || scope.powerOnOnly !== 'true') {
                        scope.toggled = !scope.toggled;
                        if (scope.onToggle) {
                            scope.onToggle({toggled: scope.toggled});
                        }
                    }
                };
            },
            template: '<div class="jv-switch verticalAlignMiddle" ng-class="{toggled: toggled}"><div class="jv-switch-icon x-large" ng-class="{{ toggled ? iconOn : iconOff }}" ng-if="!doNotShowBell"><span ng-if="toggled">'+bellOn+'</span><span ng-if="!toggled">'+bellOff+'</span></div><div ng-class="((toggled ? iconOn : iconOff) + \' \' + (toggleColorBlue ? \'jv-switch-container-blue\' : \'jv-switch-container\'))" class="x-small" ng-click="toggle()"><div class="jv-switch-handle"></div></div><div class="jv-switch-text">{{ toggled ? textOn : textOff }}</div></div>'
        };
    }
]);
